import React from "react";
import "./ImportValidationModal.css";

const ImportValidationModal = ({ validation, onCancel, onProceed, totalExisting }) => {
  if (!validation) return null;

  const { errors, warnings, duplicates, totalRows, hasErrors, hasWarnings, hasDuplicates } = validation;

  const canProceed = !hasErrors;

  return (
    <div className="validation-modal-overlay">
      <div className="validation-modal">
        <div className="validation-header">
          <h2>📋 Import-Validierung</h2>
          <button className="close-btn" onClick={onCancel}>✕</button>
        </div>

        <div className="validation-content">
          {/* Summary */}
          <div className="validation-summary">
            <div className="summary-item">
              <span className="summary-label">Zu importieren:</span>
              <span className="summary-value">{totalRows} Schüler</span>
            </div>
            <div className="summary-item">
              <span className="summary-label">Aktuell vorhanden:</span>
              <span className="summary-value">{totalExisting} Schüler</span>
            </div>
          </div>

          {/* Errors */}
          {hasErrors && (
            <div className="validation-section error-section">
              <h3>🚫 Fehler ({errors.length})</h3>
              <p className="section-description">
                Diese Fehler müssen behoben werden, bevor der Import fortgesetzt werden kann.
              </p>
              <div className="issue-list">
                {errors.slice(0, 10).map((error, index) => (
                  <div key={index} className="issue-item error">
                    {error}
                  </div>
                ))}
                {errors.length > 10 && (
                  <div className="issue-item more">
                    ... und {errors.length - 10} weitere Fehler
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Duplicates */}
          {hasDuplicates && (
            <div className="validation-section warning-section">
              <h3>⚠️ Duplikate ({duplicates.length})</h3>
              <p className="section-description">
                Diese Schüler scheinen bereits zu existieren oder sind mehrfach in der CSV.
              </p>
              <div className="issue-list">
                {duplicates.slice(0, 10).map((dup, index) => (
                  <div key={index} className="issue-item warning">
                    {dup.type === "within-csv" ? (
                      <>
                        <strong>CSV-Duplikat:</strong> {dup.student.firstName} {dup.student.lastName}
                        {dup.student.birthDate && ` (${dup.student.birthDate})`}
                        - Zeile {dup.row1} und {dup.row2}
                      </>
                    ) : (
                      <>
                        <strong>Bereits vorhanden:</strong> {dup.student.firstName} {dup.student.lastName}
                        {dup.student.birthDate && ` (${dup.student.birthDate})`}
                        - Zeile {dup.row}
                      </>
                    )}
                  </div>
                ))}
                {duplicates.length > 10 && (
                  <div className="issue-item more">
                    ... und {duplicates.length - 10} weitere Duplikate
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Warnings */}
          {hasWarnings && (
            <div className="validation-section warning-section">
              <h3>⚠️ Warnungen ({warnings.length})</h3>
              <p className="section-description">
                Diese Probleme sind nicht kritisch, sollten aber überprüft werden.
              </p>
              <div className="issue-list">
                {warnings.slice(0, 10).map((warning, index) => (
                  <div key={index} className="issue-item warning">
                    {warning}
                  </div>
                ))}
                {warnings.length > 10 && (
                  <div className="issue-item more">
                    ... und {warnings.length - 10} weitere Warnungen
                  </div>
                )}
              </div>
            </div>
          )}

          {/* All clear */}
          {!hasErrors && !hasWarnings && !hasDuplicates && (
            <div className="validation-section success-section">
              <h3>✅ Keine Probleme gefunden</h3>
              <p className="section-description">
                Alle {totalRows} Schüler können importiert werden.
              </p>
            </div>
          )}
        </div>

        <div className="validation-footer">
          {hasErrors && (
            <p className="footer-message error">
              Import kann nicht fortgesetzt werden. Bitte beheben Sie die Fehler in der CSV-Datei.
            </p>
          )}
          {!hasErrors && (hasWarnings || hasDuplicates) && (
            <p className="footer-message warning">
              ⚠️ WARNUNG: Dies löscht ALLE {totalExisting} vorhandenen Schüler und importiert {totalRows} neue Schüler!
            </p>
          )}
          {!hasErrors && !hasWarnings && !hasDuplicates && (
            <p className="footer-message success">
              ⚠️ WARNUNG: Dies löscht ALLE {totalExisting} vorhandenen Schüler und importiert {totalRows} neue Schüler!
            </p>
          )}

          <div className="footer-buttons">
            <button className="cancel-btn" onClick={onCancel}>
              Abbrechen
            </button>
            {canProceed && (
              <button className="proceed-btn" onClick={onProceed}>
                ✅ Import durchführen
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportValidationModal;
